import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DiscoveryChatQuestion, DiscoveryResponse, PossibleResponse } from '../../model/discovery-chat.interface';
import { DiscoveryQuestionTypeEnum, ResponseStateEnum } from '../../discovery-process.enum';
import { Router } from '@angular/router';
import { AbstractDiscoveryProcessService } from '../../discovery-process.abstract.service';
import { AbstractAuthorizationService } from 'src/app/moov-common/services/authorization/authorization.abstract.service';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';
import { DiscoveryStatusEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { sortBy } from 'lodash';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { FeatureID } from 'src/app/moov-common/enum/feature.enum';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { DoneDiscoveryProcessComponent } from '../../done-discovery-process/done-discovery-process.component';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';
import { UserMotivationDetails } from 'src/app/all-motivations/model/all-motivations.interface';
import { TranslateService } from '@ngx-translate/core';
import { GenderPipe } from 'src/app/moov-common/pipes/gender.pipe';
import config from 'src/app/config';
import { MatDialog } from '@angular/material/dialog';
 
@Component({
  selector: 'app-rediscover-wizard',
  templateUrl: './rediscover-wizard.component.html',
  styleUrls: ['./rediscover-wizard.component.scss']
})
export class RediscoverWizardComponent extends BaseComponent implements OnInit {
  progressBarValue = 0;
  showSaveMyProgressBtn: boolean = true;
  state = 'out';
  isLoading: boolean = false;
  questionList: DiscoveryChatQuestion[] = [];
  currentQuestionPos: number = 0;
  TOTAL_QUESTIONS_NUMBER = 66;
  currentQuestionSetId: string = "";
  lastQuestionSetId: string = "";
  presentConsultantQuestionsVideo : boolean = false;
  motivationsDetails: UserMotivationDetails[];
  rediscoverProcessCurrentState : RediscoverProcessStateEnum = RediscoverProcessStateEnum.Preliminary;
  rediscoverProcessStateEnumInstance = RediscoverProcessStateEnum;
  motivationInDispute : string = "";
  newSelectedMotivation: string = "";
  verificationResponses : number[];

  // This is an hidden input that is allowing us to scroll to top - this is ugly, but Angular.
  @ViewChild('topAnchor', {static: false}) inputEl: ElementRef;

  // we need this in order to use the enum in HTML 
  eDiscoveryQuestionTypeEnum = DiscoveryQuestionTypeEnum;
  

  constructor(private readonly discoveryProcessService: AbstractDiscoveryProcessService,
              private router: Router, 
              public dialog: MatDialog,
              private readonly authService: AbstractAuthorizationService,
              private readonly personalUserService: AbstractPersonalUserDataService,
              private readonly motivationsService: AbstractMotivationsService,
              private translate: TranslateService,
              private genderSerivce: GenderPipe) {
    super();
    this.verificationResponses = [];
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.questionList = [];
    this.newSelectedMotivation = "";
    this.motivationInDispute = "";

    // console.log(`DBG in RW ngOnInit isMobileView is ${this.isMobileView}`);

    if (this.user) {
      if (this.user.discoveryStatus != DiscoveryStatusEnum.DONE){
          // the user has navigated here by mistake
          this.router.navigate([NAVIGATION_ROUTES.app.personalView]);
          console.log(`Error in RW ngOnInit is DiscoveryStatus is not DONE`);
      }
      this.verifyPresentQuestionsVideos();
     
      this.initProcess();
    }
  }

  createFirstQuestion(): void{
      let firstQuestionResposnes: PossibleResponse[] = [];
      const questionId = "Preliminary_1"
      let idx = 1;
      // create possible responses
      for (let currMotivation of this.motivationsDetails){
          firstQuestionResposnes.push({id:currMotivation.id, idx:idx, dependency:"", questionId:questionId, motivationId:currMotivation.id, motivationScore:0, responseText:currMotivation.name})
          idx+=1;
      }

      const questionText = this.translate.instant(this.genderSerivce.transform('rediscoverProcess.introText'))
      const firstQuestion : DiscoveryChatQuestion = {id:questionId, idx:0, batchId:"", batchIdx:1, setId:"", setIdx:0, type:DiscoveryQuestionTypeEnum.MotivationGap, userResponsesNo: 1, questionText:questionText, questionWizardText:questionText, possibleResponses:firstQuestionResposnes};

      this.questionList.push(firstQuestion);
  }

  initProcess():void{
    if (!this.user){
      return;
    }

    this.motivationsService.getMotivationsForUser(this.user.id).subscribe((motivationsDetails: UserMotivationDetails[]) => {

      this.motivationsDetails = motivationsDetails;
      this.createFirstQuestion();
      this.rediscoverProcessCurrentState = RediscoverProcessStateEnum.PresentMotivationInDisputeSelection;
    });
  }

  setQuestionResponse(responses : DiscoveryResponse[]) {
    this.showLoading();

    console.log (`DBG in DW setQuestionResponse currentQuestionPos is ${this.currentQuestionPos} questionList-length is ${this.questionList.length} reponses is ${JSON.stringify(responses)}`);

    let posQuestionId = this.questionList[this.currentQuestionPos].id;
    let negQuestionId = this.questionList[this.currentQuestionPos+1].id;

    let posResponseId = responses.find(currRes => currRes.responseType === ResponseStateEnum.Positive)?.responseId;
    if (!posResponseId){
        posResponseId = "";
    }

    let negResponseId = responses.find(currRes => currRes.responseType === ResponseStateEnum.Negative)?.responseId;
    if (!negResponseId){
        negResponseId = "";
    }

    let addMoreQuestionRequiredPreCheck = false;
    if (this.currentQuestionPos >= this.questionList.length- 2){
      // showNextQuestion can be called BEFORE forkjoin ends, causing us to skip questions (pos+2 happens twice) - so we have to check this condision prior to async action
      addMoreQuestionRequiredPreCheck = true;
    }

    forkJoin({
        posResult : this.discoveryProcessService.journeySetQuestionResponse(posQuestionId, [posResponseId]),
        negResult : this.discoveryProcessService.journeySetQuestionResponse(negQuestionId, [negResponseId])
    }).subscribe(({posResult, negResult })=>{
        if (addMoreQuestionRequiredPreCheck){
            // we need to get next batch, fot that we need to wait to set response to end
            console.log (`DBG in DW setQuestionResponse in fork join`);
            this.showNextQuestion();
        }
    });

    if (this.currentQuestionPos < this.questionList.length- 2){
        // we only call show next question, no need to wait for set response to end
        console.log (`DBG in DW setQuestionResponse outside of ForkJoin`);
        this.showNextQuestion();
    }
}

verifyPresentQuestionsVideos(): void{
  this.personalUserService.verifyFeature(FeatureID.discoveryConsultantQuestionsVideos).subscribe(res => {
    this.presentConsultantQuestionsVideo = res;
  });
}

setUserResponse (response: DiscoveryResponse[]){
  switch (this.rediscoverProcessCurrentState){
    case (RediscoverProcessStateEnum.PresentMotivationInDisputeSelection):{
      this.setMotivationInDisputeResponse(response);
      break;
    }
    case (RediscoverProcessStateEnum.PresentMotivationVerificationQuestions):{
      this.setMotivationVerificationResponse(response);
      break;
    }
    case (RediscoverProcessStateEnum.PresentResultForVerificationProcess):{
      this.continueProcessAfterVerification();
      break;
    }
    case (RediscoverProcessStateEnum.PresentTailQuestion):{
      this.setResponseToTailQuestion(response);
      break;
    }
    case (RediscoverProcessStateEnum.PresentMotivationGapQuestion):{
      this.setMotivationGap(response);
      break;
    }
  }
}


setMotivationInDisputeResponse(response : DiscoveryResponse[]){
  this.showLoading();

  // get the motivationId and save it as the motivationInDispute
  // response Id is the motivationId
  const currResponse = response[0];
  this.motivationInDispute = currResponse.responseId;

  // set the state to next phase 
  this.rediscoverProcessCurrentState = RediscoverProcessStateEnum.PresentMotivationVerificationQuestions;

  //get the next phase questions
  this.discoveryProcessService.rediscoverGetQuestionsForMotivation(this.motivationInDispute).subscribe(questions => {
    this.questionList = questions;
    this.currentQuestionPos = 0;
    
    // prep to get the reponses for later phase
    this.verificationResponses = [];
    this.hideLoading();
  });
}

setMotivationVerificationResponse(response : DiscoveryResponse[]){
  
  const selectedResponse:PossibleResponse | undefined = this.questionList[this.currentQuestionPos].possibleResponses.find(possibleResponse => possibleResponse.id == response[0].responseId);

  if (selectedResponse == undefined){
    console.log ('Error setMotivationVerificationResponse could not find response');
    return;
  }

  this.verificationResponses.push(selectedResponse.motivationScore);

  // console.log(`in RW setMotivationVerificationResponse score ${selectedResponse.motivationScore} verificationResponses ${JSON.stringify(this.verificationResponses)}`);

  if (this.currentQuestionPos < this.questionList.length - 1){
    this.currentQuestionPos += 1;
  }
  else{
    // Summarize user Responses

    let verificationScore : number = 0;
    for (let currResponseScore of this.verificationResponses){
      verificationScore += currResponseScore;
      // console.log(`in RW setMotivationVerificationResponse currResponseScore ${currResponseScore} total = ${verificationScore}`);
    }


    // console.log (`in RW setMotivationVerificatioResponse config.rediscoverMinimalScoreToContinue is ${config.rediscoverMinimalScoreToContinue}`);

    // Create verificationResult question 
    this.questionList = [];
    let questionText = "";
    const motivationInDisputeName = this.motivationsService.getMotivationName(this.motivationInDispute);

    if (verificationScore >= config.rediscoverMinimalScoreToContinue){
      questionText = this.translate.instant(this.genderSerivce.transform('rediscoverProcess.verificationFailed'),{driverName:motivationInDisputeName});
    }
    else{
      questionText = this.translate.instant(this.genderSerivce.transform('rediscoverProcess.verificationSucceeded'),{driverName:motivationInDisputeName});
    }

    const questionId = "verificationResult";
    const firstQuestion : DiscoveryChatQuestion = {id:questionId, idx:0, batchId:"", batchIdx:1, setId:"", setIdx:0, type:DiscoveryQuestionTypeEnum.MotivationGap, userResponsesNo: 0, questionText:questionText, questionWizardText:questionText, possibleResponses:[]};

    // Add to questionList
    this.currentQuestionPos = 0;
    this.questionList.push(firstQuestion);
    this.rediscoverProcessCurrentState = RediscoverProcessStateEnum.PresentResultForVerificationProcess;
  }
}

continueProcessAfterVerification(){
  this.showLoading();

  this.discoveryProcessService.rediscoverGetTailQuestion(this.motivationInDispute).subscribe(tailQuestion => {
    this.questionList = []
    this.questionList.push(tailQuestion[0]);
    this.currentQuestionPos = 0;
    // find the alternatvie motivation
    this.rediscoverProcessCurrentState = RediscoverProcessStateEnum.PresentTailQuestion;

    // add tail to questionList
    this.hideLoading();
  });
}

setResponseToTailQuestion(response : DiscoveryResponse[]){
  this.showLoading();

  const selectedResponse:PossibleResponse | undefined = this.questionList[this.currentQuestionPos].possibleResponses.find(possibleResponse => possibleResponse.id == response[0].responseId);
  
  if (selectedResponse == undefined){
    console.log('Error setResponseToTailQuestion - response was not found');
    return;
  }
  
  this.newSelectedMotivation = selectedResponse.motivationId;

  // add motivationGap question to questionList
  this.discoveryProcessService.rediscoverGetMotivationGapQuestion(this.newSelectedMotivation).subscribe(gapQuestion => {
    this.questionList = []
    let currentQuestion = gapQuestion[0];
    currentQuestion.questionText = this.translate.instant(this.genderSerivce.transform('rediscoverProcess.motivationGapPrefix')) + " " + currentQuestion.questionText;
    this.questionList.push(currentQuestion);
    this.currentQuestionPos = 0;
    // save the selected motivation and call the motivationGap Question
    this.rediscoverProcessCurrentState = RediscoverProcessStateEnum.PresentMotivationGapQuestion

    // add tail to questionList
    this.hideLoading();
  });

}

setMotivationGap(response : DiscoveryResponse[]){
  this.showLoading();

  const selectedResponse:PossibleResponse | undefined = this.questionList[this.currentQuestionPos].possibleResponses.find(possibleResponse => possibleResponse.id == response[0].responseId);

  if (selectedResponse == undefined){
    console.log ('Error setMotivationGap could not find response');
    return;
  }
  // update motivation in server
  this.discoveryProcessService.rediscoverUpdateUserMotviation(this.motivationInDispute, this.newSelectedMotivation, selectedResponse.motivationScore).subscribe(res => {

    // present done to user
    // navigate to myMotivations
    console.log (`in RW setMotivationGap after calling rediscoverUpdateUserMotviation`);
    this.hideLoading();
    this.showDone();
  });
}


setQuestionMotivationResponse(responses : DiscoveryResponse[]) {
  this.showLoading();

  // get the motivationId and save it as the motivationInDispute
  // get next questions 
  // set the state to next phase 

  let questionId = this.questionList[this.currentQuestionPos].id;

  let responseId = responses[0].responseId;

  let addMoreQuestionRequiredPreCheck = false;
  if (this.currentQuestionPos >= this.questionList.length- 1){
    // showNextQuestion can be called BEFORE forkjoin ends, causing us to skip questions (pos+2 happens twice) - so we have to check this condision prior to async action
    addMoreQuestionRequiredPreCheck = true;
  }

  this.discoveryProcessService.journeySetQuestionResponse(questionId, [responseId]).subscribe(result=>{
      if (addMoreQuestionRequiredPreCheck){
          // we need to get next batch, fot that we need to wait to set response to end
          this.showNextQuestion();
      }
    });

  if (this.currentQuestionPos < this.questionList.length- 1){
      // we only call show next question, no need to wait for set response to end
      this.showNextQuestion();
  }
}

setQuestionTailResponse(responses : DiscoveryResponse[]) {
  this.showLoading();

  let questionId = this.questionList[this.currentQuestionPos].id;

  let responsesIds: string[] = [];
  for (let currResponse of responses){
    responsesIds= responsesIds.concat(currResponse.responseId);
  }
  
  let addMoreQuestionRequiredPreCheck = false;
  if (this.currentQuestionPos >= this.questionList.length- 1){
    // showNextQuestion can be called BEFORE forkjoin ends, causing us to skip questions (pos+2 happens twice) - so we have to check this condision prior to async action
    addMoreQuestionRequiredPreCheck = true;
  }

  console.log (`DBG DW in setQuestionTailResponse questionId is ${questionId} reponsesIds is ${JSON.stringify(responsesIds)}`);

  this.discoveryProcessService.journeySetQuestionResponse(questionId, responsesIds).subscribe(result=>{
      if (addMoreQuestionRequiredPreCheck){
          // we need to get next batch, fot that we need to wait to set response to end
          this.showNextQuestion();
      }
    });

  if (this.currentQuestionPos < this.questionList.length- 1){
      // we only call show next question, no need to wait for set response to end
      this.showNextQuestion();
  }
}

private async showNextQuestion() {
  
  this.questionList[this.currentQuestionPos].isAnswered = true;
  let questionDelta = 1;

  if (this.questionList[this.currentQuestionPos].type == DiscoveryQuestionTypeEnum.Standard){
    this.questionList[this.currentQuestionPos+1].isAnswered = true;
    questionDelta = 2;
  }

  if (this.currentQuestionPos < this.questionList.length- questionDelta) {
      this.currentQuestionPos+=questionDelta;
      this.hideLoading();

      // scroll to top - this is ugly as hell, angular...
      setTimeout(() => this.inputEl.nativeElement.focus());
  } else {
      await this.getNextBatchOrDone();
  }
}

cancelProcess() {
  this.router.navigate([NAVIGATION_ROUTES.app.personalView]);
}

private async getNextBatchOrDone() {
  // console.log(`getting next batch`);
  let batchResponse = await  firstValueFrom(this.discoveryProcessService.journeyGetQuestionsInBatch());
  
  this.hideLoading();
  
  if (batchResponse && batchResponse.length > 0) {
      // console.log(`batch added ${batchResponse.length} questions`);
      batchResponse = sortBy(batchResponse, ['batchIdx']);

      this.questionList = this.questionList.concat(batchResponse);
      // console.log(`after adding batch this.questionList.length: ${this.questionList.length}`);
      let questionDelta = 1;
  
      if (this.questionList[this.currentQuestionPos].type == DiscoveryQuestionTypeEnum.Standard){
        questionDelta = 2;
      }

      this.currentQuestionPos+=questionDelta;
      
      // scroll to top - this is ugly as hell, angular...
      setTimeout(() => this.inputEl.nativeElement.focus());     
  } else {
      this.showDone();
  }
}

  private showDone() {

  // this.analytics.discoveryProcessCompletedEvent();

  this.authService.updateLoggedInUserToken().subscribe(res => {
      const dialogRef = this.dialog.open(DoneDiscoveryProcessComponent, {
          height: '40%',
          width: '60%'
      });
      
      dialogRef.afterClosed().subscribe( res =>{
          this.router.navigate([NAVIGATION_ROUTES.app.personalView]);
      });
  });
  }
  
  private showLoading() {
    this.isLoading = true;
  }

  private hideLoading() {
    this.isLoading = false;
  }  
}

export enum RediscoverProcessStateEnum{
  Preliminary = 1,
  PresentMotivationInDisputeSelection = 2,
  PresentMotivationVerificationQuestions = 3,
  PresentResultForVerificationProcess = 4,
  PresentTailQuestion = 5,
  PresentMotivationGapQuestion = 6,
  EndProcess = 7
}